import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "@/utils/axiosInstance";
import { handleThunkError } from "@/utils/thunkErrorHandler";

export interface ProfileFormData {
  name: string;
  email: string;
  phone?: string;
  cpf?: string;
  password?: string;
  password_confirmation?: string;
  address?: string;
}

const endpoint = {
  profile: "/profile",
  me: "/me",
};

export const fetchMe = createAsyncThunk(
  "profile/fetchMe",
  async (_params: { noCache?: boolean } = {}, thunkAPI) => {
    try {
      // Prefer /me, fallback para /profile
      const url = endpoint.me;
      const response = await axiosInstance.get(
        `${url}${_params.noCache ? `?ts=${Date.now()}` : ""}`,
      );
      return response.data;
    } catch (error) {
      // Tenta fallback em /profile
      try {
        const response = await axiosInstance.get(endpoint.profile);
        return response.data;
      } catch (err) {
        return handleThunkError(err, thunkAPI, "Erro ao carregar perfil");
      }
    }
  },
);

export const updateProfile = createAsyncThunk(
  "profile/updateProfile",
  async (data: ProfileFormData, thunkAPI) => {
    try {
      const response = await axiosInstance.put(endpoint.profile, data);
      return response.data;
    } catch (error) {
      return handleThunkError(error, thunkAPI, "Erro ao atualizar perfil");
    }
  },
);
